import {
  annotation,
  annotationCalloutRect,
  annotationCalloutElbow,
  annotationLabel,
} from "d3-svg-annotation";
import num2string from "./num2string.js";

export default {
  "diff-chart": ({ width, height, data }) => ({
    note: {
      label: `The white region represents the difference between girl and boy population. In this case, in 2011, at age 18, India had ${num2string(
        data.male - data.female
      )} more males, than females`,
      title: "Gender gap",
      bgPadding: 10,
      wrap: 200,
    },
    connector: {
      end: "arrow",
    },
    color: "#E8336D",
    data: data,
    dy: 50,
    dx: 100,
    subject: {
      width,
      height,
    },
    className: "pop-annotation",
  }),
  "legend-diff": ({ width, height, data }) => ({
    note: {
      title: "Gender gap",
      bgPadding: 5,
    },
    connector: {
      type: "line",
      end: "arrow",
    },
    // color: "#E8336D",
    data: data,
    dy: 200,
    dx: -30,
    type: annotationCalloutRect,
    subject: {
      width,
      height,
    },
    className: "legend-annotation",
  }),
  "legend-adult-line": ({ x, y }) => ({
    note: {
      title: "Age 18 marker",
      bgPadding: 3,
      align: "middle",
      lineType: "vertical",
    },
    type: annotationLabel,
    connector: {
      end: "arrow",
    },
    x,
    y,
    dy: 0,
    dx: -140,
  }),
  "legend-trend-line": ({ x, y }) => ({
    note: {
      title: "Trend line",
      bgPadding: 5,
      align: "middle",
      lineType: "horizontal",
    },
    type: annotationLabel,
    connector: {
      end: "arrow",
    },
    x,
    y,
    dy: 100,
    dx: 0,
  }),
  "legend-shortcode": ({ x, y }) => ({
    note: {
      title: "State short code",
      bgPadding: 5,
      align: "middle",
      lineType: "horizontal",
    },
    type: annotationLabel,
    connector: {
      end: "arrow",
    },
    x,
    y,
    dy: -105,
    dx: 0,
  }),
  "legend-up-comparison": ({ x, y }) => ({
    note: {
      title: "Population compared to Uttar Pradesh",
      bgPadding: 5,
      align: "middle",
      lineType: "horizontal",
      wrap: 200,
    },
    type: annotationLabel,
    connector: {
      end: "arrow",
    },
    x,
    y,
    dy: -80,
    dx: 40,
  }),
  "legend-rj-comparison": ({ x, y }) => ({
    note: {
      title: "Area compared to Rajasthan",
      bgPadding: 5,
      align: "middle",
      lineType: "horizontal",
      wrap: 200,
    },
    type: annotationLabel,
    connector: {
      end: "arrow",
    },
    x,
    y,
    dy: -55,
    dx: 25,
  }),
};
